import React from 'react';
import ATSResumeTemplate from './ATSResumeTemplate';
function ATSClassic(props) { return <ATSResumeTemplate {...props} variant="classic" />; }
export default ATSClassic;